import { bmoApi } from '../../api';
import * as UserActions from '../user/actions';
import { partnerApi } from '../../api';   /*Separate Partners from Operators Filter*/

export async function searchBMOJson(token, id) {
  const apiResponse = await bmoApi.getBMO(token,id);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['state'] = true;
    obj['data'] = respJson;
  } else {
    obj['state'] = false;
    obj['msg'] = respJson;
  }
  return obj;

}

export async function sendMailToBMOJson(token, formdata) {
  const apiResponse = await bmoApi.sendEmailToBMO(token,formdata);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['state'] = true;
    obj['data'] = respJson;
  } else {
    obj['state'] = false;
    obj['msg'] = respJson;
  }
  return obj;

}

export function searchBMOSJson(token, page, formdata) {
  return async dispatch => {
    try {
      dispatch({ type: 'RESET_BMOS' });
      dispatch({ type: 'LOADING_BMOS', loading: true, error: '' });

      const apiResponse = await bmoApi.searchBMOs(token, page, formdata);
      const respJson = await apiResponse.json();
      let partnerobj = [];  /*Separate Partners from Operators Filter*/
      console.log(respJson);

      //To fetch Partners data  /*Separate Partners from Operators Filter*/
      let partnersformdata = {
        "posts_per_page": 1000,
        "posts_status": ["publish"]
    }
   
      const partnersapiResponse =   await partnerApi.searchPartners(token, 1, partnersformdata);
      const partnersrespJson = await partnersapiResponse.json();
      if(partnersapiResponse.status === 200)
      {
        let partnerresultobj = {};
        
        partnerresultobj['result'] = partnersrespJson['data'];
        
        partnerresultobj['result'].map((data,index) => {
          const {post_title} = data
         
          partnerobj.push(post_title.toLowerCase());
          
        });
      }
      //To fetch Partners data  /*Separate Partners from Operators Filter*/

      if (apiResponse.status === 200) {
        let obj = {};
        obj['max_num_pages'] = respJson['max_num_pages'];
        obj['currentpage'] = respJson['currentpage'];
        obj['selected'] = respJson['selected'];
        obj['result'] = respJson['result'];

         //To filter bridge from BMO list /*Separate Partners from Operators Filter*/
         let result_partners_index =[];            //code to remove partners from bmos array
         obj['result'].map((data,bmoindex) => {
           const {name} = data
           
           //Commented -to fix remove bridge index after partners removal from bmos array
           /*
           if(name.toLowerCase().startsWith('bridge') == true)
           {
             obj['result'].splice(bmoindex,1);
           }
           */
           
           for (var i = 0; i < partnerobj.length; i++) {
             if(name.toLowerCase().startsWith(partnerobj[i]) == true)
             {
               //obj['result'].splice(bmoindex,1);    //code to remove partners from bmos array
               result_partners_index.push(bmoindex);  //code to remove partners from bmos array
               break;                                 //code to remove partners from bmos array
 
             }
         }
            
         });
 
         //code to remove partners from bmos array
         for(var r=result_partners_index.length-1; r>=0; r--)
         {
           obj['result'].splice(result_partners_index[r],1);
         }

         //Code to remove bridge from bmos array
         obj['result'].map((data,bridgeindex) => {
          const {name} = data
          if(name.toLowerCase().startsWith('bridge') == true)
          {
            obj['result'].splice(bridgeindex,1);
          }
        });

         //code to remove partners index in bmos array
 
         //To filter bridge from BMO list   /*Separate Partners from Operators Filter*/


        dispatch({ type: 'SET_BMOS', data: obj });
        dispatch({ type: 'LOADING_BMOS', loading: false, error: '' });

      } else if (apiResponse.status === 403) {
        dispatch({ type: 'LOADING_BMOS', loading: false, error: '' });
        UserActions.logoutWithDispatch(dispatch);

      } else {
        dispatch({ type: 'LOADING_BMOS', loading: false, error: respJson });
      }
    } catch (error) {
      dispatch({ type: 'LOADING_BMOS', loading: false, error: error });
    }

  }
}



